// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as _googleTypes from 'signin-with-google-types'

import api from 'js/api'
import { googleLoginId } from 'js/config'
import { captureException } from 'js/utils/captureException'

function getLoginToken() {
  return new Promise((resolve, reject) => {
    function handlePromptFailure(failure) {
      reject(failure)
      captureException(
        new Error(
          `LoginWithGoogleError: type: ${failure.type}, reason: ${failure.reason}`
        ),
        { fingerprint: ['LoginWithGoogleError', failure.type, failure.reason] }
      )
    }

    const googleSignInButtonId = 'googleSignInButton'
    function renderSignInButton() {
      const googleSignInButton = document.getElementById(googleSignInButtonId)
      googleSignInButton?.classList.remove('hidden')
      window.google.accounts.id.renderButton(
        googleSignInButton as HTMLElement,
        {
          theme: 'outline',
          size: 'large',
          text: 'continue_with',
        }
      )
    }

    window.google.accounts.id.initialize({
      client_id: googleLoginId as string,
      callback: ({ credential }) => {
        resolve(credential)
      },
    })
    window.google.accounts.id.prompt((notification) => {
      if (notification.isNotDisplayed()) {
        const reason = notification.getNotDisplayedReason()

        if (
          [
            'browser_not_supported',
            'opt_out_or_no_session',
            'suppressed_by_user',
          ].includes(reason) &&
          document.getElementById(googleSignInButtonId)
        ) {
          renderSignInButton()
        } else {
          handlePromptFailure({
            type: 'not-displayed',
            reason,
          })
        }
      }
      if (notification.isDismissedMoment()) {
        const reason = notification.getDismissedReason()
        if (reason !== 'credential_returned') {
          handlePromptFailure({
            type: 'dismissed',
            reason,
          })
        }
      }
      if (notification.isSkippedMoment()) {
        handlePromptFailure({
          type: 'skipped',
          reason: notification.getSkippedReason(),
        })
      }
    })
  })
}

export const loginWithGoogle = () => {
  return new Promise((resolve, reject) => {
    getLoginToken()
      .then((token) => {
        return api('POST', 'gatekeeper/v1/login/google/token', {
          token,
        })
      })
      .then(({ access_token, expires_at, refresh_token }) => {
        resolve({
          access_token,
          expires_at,
          refresh_token,
        })
      })
      .catch((error) => {
        return reject(error)
      })
  })
}
